
// SVG Icon: lock
export default { id: "terriajs-lock" };
export const id = "terriajs-lock";
export const name = "lock";
